"use client";
import mobile_menu_data from "@/data/memo-menu-data";
import Link from "next/link";
import React, { useContext, useState } from "react";
import { AppContext } from "@/contextApi/AppProvider";
import { AppContextType } from "@/interFace/general";
import { getLink } from "@/constants";
import { useTranslations } from "next-intl";
import { Translations } from "@/translations";
import { resolvePostLoginUrl } from "@/lib/Auth/postLoginRedirect";

const MenuTwo = () => {
  const [submenuOpen, setSubmenuOpen] = useState<number>(0);
  const [open, setOpen] = useState<boolean>(false);
  const t = useTranslations("General");

  const { toggleSideMenu, sideMenuOpen, locale, currentUser, userInfo } = useContext(
      AppContext
    ) as AppContextType;
  const homepageItem = mobile_menu_data[0];
  const menuItems = currentUser?.uid && homepageItem
    ? [
        homepageItem,
        {
          id: 99,
          hasDropdown: false,
          title: Translations.General.Dashboard,
          link: resolvePostLoginUrl({
            locale,
            defaultWorkspace: userInfo.defaultWorkspace,
            roles: userInfo.roles,
            activeRole: userInfo.activeRole,
          }),
        },
      ]
    : mobile_menu_data;

  const handleMenuToggle = (id: number) => {
    setSubmenuOpen(id);
    setOpen(!open);
  };

  return (
    <>
      {menuItems?.length &&
        menuItems?.map((item) => (
          <li
            onClick={() => handleMenuToggle(item.id)}
            key={item.id}
            className={`${
              item.hasDropdown && submenuOpen === item.id && open === true
                ? "menu-item-has-children has-droupdown active"
                : `${
                    item.hasDropdown
                      ? "menu-item-has-children has-droupdown"
                      : ""
                  }`
            }`}
          >
            <Link onClick={toggleSideMenu} href={getLink(locale, item.link)} className={item.isBtn ? "e-btn text-decoration-none" : "text-decoration-none"}> {t(item.title as keyof typeof Translations.General)} </Link>
            {item.hasDropdown === true && (
              <ul
                className={
                  item.submenus && submenuOpen === item.id && open === true
                    ? "submenu active"
                    : "submenu"
                }
                style={{
                  display:
                    item.submenus && submenuOpen === item.id && open === true
                      ? "block"
                      : "none",
                }}
              >
                {item?.submenus?.length &&
                  item?.submenus.map((data, index) => (
                    <li key={index}>
                      <Link href={getLink(locale, data.link)} className="text-decoration-none">{t(data.title as keyof typeof Translations.General)}</Link>
                    </li>
                  ))}
              </ul>
            )}
          </li>
        ))}
    </>
  );
};

export default MenuTwo;
